const repositoriesDefault = [
  {
    full_name: 'facebook/react',
    description:
      'A declarative, efficient, and flexible JavaScript library for building user interfaces.',
    owner: {
      login: 'facebook',
      avatar_url: 'https://avatars3.githubusercontent.com/u/69631?v=4',
    },
  },
  {
    full_name: 'LeeonardoVargas/fast-feet',
    description:
      'Desafio Final do Bootcamp, uma aplicação completa (Back-end, Front-end e Mobile) que é avaliada para emissão do Certificado.',
    owner: {
      login: 'LeeonardoVargas',
      avatar_url: 'https://avatars2.githubusercontent.com/u/11177716?v=4',
    },
  },
  {
    full_name: 'r-spacex/SpaceX-API',
    description:
      '🚀 Open Source REST API for rocket, core, capsule, pad, and launch data.',
    owner: {
      login: 'r-spacex',
      avatar_url: 'https://avatars3.githubusercontent.com/u/29695396?v=4',
    },
  },
  {
    full_name: 'gatsbyjs/gatsby',
    description: 'Build blazing fast, modern apps and websites with React.',
    owner: {
      login: 'gatsbyjs',
      avatar_url: 'https://avatars1.githubusercontent.com/u/12551863?v=4',
    },
  },
  {
    full_name: 'Rocketseat/unform',
    description: 'Easy peasy highly scalable ReactJS & React Native forms! 🚀',
    owner: {
      login: 'Rocketseat',
      avatar_url: 'https://avatars0.githubusercontent.com/u/28929274?v=4',
    },
  },
  {
    full_name: 'googlesamples/google-services',
    description:
      'A collection of quickstart samples demonstrating the Google APIs for Android and iOS.',
    owner: {
      login: 'googlesamples',
      avatar_url: 'https://avatars3.githubusercontent.com/u/7378196?v=4',
    },
  },
  {
    full_name: 'angular/angular',
    description: 'One framework. Mobile & desktop.',
    owner: {
      login: 'angular',
      avatar_url: 'https://avatars3.githubusercontent.com/u/139426?v=4',
    },
  },
  {
    full_name: 'eslint/eslint',
    description: 'Find and fix problems in your JavaScript code.',
    owner: {
      login: 'eslint',
      avatar_url: 'https://avatars3.githubusercontent.com/u/6019716?v=4',
    },
  },
];

export default repositoriesDefault;
